import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function PackEliteDetails() {
  return <section className="py-10 md:py-20 bg-white border-y border-gray-100" data-id="element-179">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-180">
        <div className="text-center mb-8 md:mb-16" data-id="element-181">
          <h2 className="text-2xl md:text-5xl font-bold font-serif text-secondary-dark mb-2 md:mb-4" data-id="element-182">
            ¿Qué agrega el Pack Élite™?
          </h2>
          <p className="text-base md:text-xl text-gray-600 font-medium" data-id="element-183">
            El sistema para instructoras que no solo quieren enseñar — quieren
            crecer
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12" data-id="element-184">
          {/* Block 1 */}
          <div className="bg-accent rounded-2xl md:rounded-3xl p-5 md:p-8 border border-primary-light/50" data-id="element-185">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8 pb-4 md:pb-6 border-b border-gray-200" data-id="element-186">
              <span className="text-3xl md:text-5xl" data-id="element-187">💃</span>
              <div data-id="element-188">
                <h3 className="text-lg md:text-2xl font-bold text-gray-900" data-id="element-189">
                  COREOGRAFÍAS COMPLETAS RESUELTAS
                </h3>
                <p className="text-primary font-medium italic text-xs md:text-base" data-id="element-190">
                  "20 coreografías listas para usar en exhibiciones y
                  competencias"
                </p>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6" data-id="element-191">
              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-192">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-193">
                  No sabés cómo estructurar una coreografía para tus alumnas
                </div>
                <div className="flex items-start gap-2" data-id="element-194">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-195" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-196">
                    8 coreografías completas para nivel iniciación (4 a 6 años)
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-197">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-198">
                  Tus exhibiciones siempre quedan improvisadas o incompletas
                </div>
                <div className="flex items-start gap-2" data-id="element-199">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-200" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-201">
                    8 coreografías completas para nivel intermedio (7 a 9 años)
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-202">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-203">
                  No tenés material coreográfico para alumnas avanzadas
                </div>
                <div className="flex items-start gap-2" data-id="element-204">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-205" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-206">
                    4 coreografías completas para nivel avanzado (10 a 12 años)
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-207">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-208">
                  No sabés cómo dirigir el ensayo y la puesta en escena
                </div>
                <div className="flex items-start gap-2" data-id="element-209">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-210" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-211">
                    Guía completa de montaje, ensayo y presentación final
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Block 2 */}
          <div className="bg-secondary-light/30 rounded-2xl md:rounded-3xl p-5 md:p-8 border border-secondary-light" data-id="element-212">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8 pb-4 md:pb-6 border-b border-gray-200" data-id="element-213">
              <span className="text-3xl md:text-5xl" data-id="element-214">🏫</span>
              <div data-id="element-215">
                <h3 className="text-lg md:text-2xl font-bold text-gray-900" data-id="element-216">
                  ACADEMIA DE RÍTMICA: CREÁ Y GESTIONÁ TU NEGOCIO
                </h3>
                <p className="text-secondary font-medium italic text-xs md:text-base" data-id="element-217">
                  "Abrí, organizá y llenó tu academia de gimnasia rítmica"
                </p>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6" data-id="element-218">
              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-219">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-220">
                  No sabés cómo montar tu propia academia desde cero
                </div>
                <div className="flex items-start gap-2" data-id="element-221">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-secondary flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-223">
                    Guía paso a paso para crear tu academia o espacio propio
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-224">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-225">
                  Cobrás lo mismo de siempre sin poder justificar una suba
                </div>
                <div className="flex items-start gap-2" data-id="element-226">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-secondary flex-shrink-0 mt-0.5" data-id="element-227" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-228">
                    Estructura de precios, tarifas y modalidades de cobro
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-229">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-230">
                  No tenés presencia profesional en redes sociales
                </div>
                <div className="flex items-start gap-2" data-id="element-231">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-secondary flex-shrink-0 mt-0.5" data-id="element-232" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-233">
                    Marketing en Instagram y Facebook para academias de rítmica
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 md:gap-2" data-id="element-234">
                <div className="text-gray-500 text-xs md:text-sm line-through" data-id="element-235">
                  No contás con documentación profesional para tu negocio
                </div>
                <div className="flex items-start gap-2" data-id="element-236">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-secondary flex-shrink-0 mt-0.5" data-id="element-237" />
                  <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-238">
                    Contratos, reglamentos y documentación básica lista para
                    usar
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}